import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ListIcon from "@mui/icons-material/List";
import ListBrowser, { getListBrowserStore } from "@ts-private/list-browser";
import { useApolloFetching } from "@ts-private/list-browser-apollo-extensions";
import { Card } from "@totalsoft/rocket-ui";
import ListItem from "./ListItem";
import { PARTNER_LIST_QUERY } from "../queries";
import { useListBrowserFunctions } from "hooks/useListBrowserFunctions";
import { withParams } from "providers/ParamsConsumer";

const selfPartnerListStore = getListBrowserStore({
  name: "selfPartner-browser",
  filterDefinitions: [
    {
      name: "partnerName",
      caption: "Partner.Name",
      type: "text"
    },
    {
      name: "uniqueId",
      caption: "Partner.UniqueID",
      type: "text"
    }
  ],
  orderByFields: [
    {
      caption: "Partner.UniqueID",
      value: "UniqueId"
    },
    {
      caption: "Partner.Name",
      value: "PartnerName"
    }
  ],
  pager: {
    orderBy: "PartnerName",
    direction: "asc"
  }
});

const SelfPartnerListBrowser = ({ params }) => {
  const getSelfPartnerListFetchingOptions = useMemo(() => {
    return {
      queryOptions: {
        query: PARTNER_LIST_QUERY,
        name: "partners",
        fetchPolicy: "network-only",
        variables: { filters: { partnerTypeId: params.selfPartnerTypeId } }
      }
    };
  }, [params.selfPartnerTypeId]);

  useApolloFetching(selfPartnerListStore, getSelfPartnerListFetchingOptions);
  const { textResolver } = useListBrowserFunctions();

  return (
    <Card icon={ListIcon}>
      <ListBrowser store={selfPartnerListStore} ItemComponent={ListItem} textResolver={textResolver} />
    </Card>
  );
};

SelfPartnerListBrowser.propTypes = {
  params: PropTypes.object.isRequired
};

export default withParams(SelfPartnerListBrowser);
